import { Button, Modal, message, Upload, Typography, Alert } from "antd";
import React, { useState, useEffect } from "react";
import {
  InboxOutlined,
  FileZipFilled,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { postAPI } from "../Services/Api";

import { NEAR_MAP_SINGLE, FETCH_PARCEL } from "../Constants/URLs";

import FileUploadLine from "../Assets/FileUploadLine.svg";
import { formatCurrentDate } from "../Utils/HelperFunctions";
import classes from "./Dashboard.module.css";

const CheckFileUploadModal = ({ checkNearMap = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [isUploaded, setIsUploaded] = useState(false);
  const [uploadedFile, setuploadedFile] = useState({});
  const fileFormat = checkNearMap ? ".geojson" : ".csv";
  const payloadKey = checkNearMap ? "parcel_geojson" : "addresses_file";
  const url = checkNearMap ? NEAR_MAP_SINGLE : FETCH_PARCEL;

  const resetData = () => {
    setIsOpen(false);
    setIsUploaded(false);
    setuploadedFile({});
  };
  const handleDelete = () => {
    setuploadedFile({});
    setIsUploaded(false);
    message.error("File removed");
  };
  const { Dragger } = Upload;
  const props = {
    accept: fileFormat,
    beforeUpload: (file) => {
      setIsOpen(false);
      setIsUploaded(true);
      setuploadedFile(file);
      return false;
    },
    showUploadList: false,
  };
  const handleSubmit = () => {
    try {
      setIsUploaded(false);
      setIsUploading(true);
      let formData = new FormData();
      formData.append(payloadKey, uploadedFile);
      postAPI(url, formData).then(() => {
        message.success({
          content: checkNearMap
            ? "Upload successful, system will check the coverage for the input parcels and you will receive an email shortly."
            : "Parcels zip file will be sent over slack channel.",
          style: { color: "green" },
        });
      });
      setIsUploading(false);
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <Button
        type="primary"
        className={classes.batchBtn}
        loading={isUploading}
        onClick={() => setIsOpen(true)}
        icon={
          <img
            src={FileUploadLine}
            alt="Upload"
            style={{ width: "1rem", height: "1rem", marginRight: "5px" }}
          />
        }
      >
        {" "}
        {isUploading
          ? "Processing your parcel"
          : checkNearMap
          ? "Check nearmap"
          : "Check Parcel"}{" "}
      </Button>
      <Modal
        visible={isOpen}
        title="Upload file"
        onCancel={() => resetData()}
        footer={[]}
      >
        <Dragger {...props}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">
            Click or drag file to this area to upload
          </p>
        </Dragger>
      </Modal>
      <Modal
        visible={isUploaded}
        title="Upload file"
        onCancel={() => resetData()}
        footer={[]}
      >
        <div className={classes.cardRowContainer}>
          <div className={classes.cardInfoContainer}>
            <FileZipFilled className={classes.fileIcon} />
            <div className={classes.fileDetailContainer}>
              <Typography className={classes.fileUpperDetail}>
                {uploadedFile.name}
              </Typography>
              <div style={{ display: "flex" }}>
                <Typography className={classes.fileLowerDetail}>
                  {formatCurrentDate()}
                </Typography>
                <Typography className={classes.fileLowerDetail}>
                  <span style={{ fontWeight: "bold", paddingLeft: "4px" }}>
                    ·
                  </span>{" "}
                  {Math.floor(uploadedFile.size / 1000)} Kb
                </Typography>
              </div>
            </div>
          </div>
          <div className={classes.closeCircleOutlinedContainer}>
            <CloseCircleOutlined
              style={{ fontSize: "1.5rem" }}
              onClick={() => handleDelete()}
            />
          </div>
        </div>
        <div className={classes.uploadBtnContainer}>
          <Button type="primary" onClick={() => handleSubmit()}>
            Submit
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default React.memo(CheckFileUploadModal);
